<template>
    <div id="browse">
        <Navi :currentPage="page_num" v-if="update"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Browse</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div v-if="loading" class="pcga-loading">
                <el-row
                    v-loading="true"
                    element-loading-background="rgba(255, 255, 255, 1)"
                    style="height:100%"
                ></el-row>
                <!-- <pcga-loading></pcga-loading> -->
            </div>
            <div v-if="!loading">
                <el-container style="border: 1px solid #eee; margin:20px 5px;">
                    <el-aside width="400px">
                        <el-container style="height: 800px; ">
                            <el-header height="40px">
                                <div class="pcga-show-record">Browse Tree</div>
                            </el-header>
                            <el-main>
                                <!-- <p>Click tree to show related records</p> -->
                                <el-tree
                                    :data="treeData"
                                    :props="treeProps"
                                    @node-click="handleNodeClick"
                                    ref="tree"
                                    :highlight-current="true"
                                ></el-tree>
                            </el-main>
                        </el-container>
                    </el-aside>
                    <el-container style="height: 800px; " v-if="item != ''">
                        <el-header height="40px">
                            <div class="pcga-show-record">{{ n_record }}</div>
                        </el-header>
                        <el-main>
                            <vxe-table
                                :row-key="true"
                                :scroll-y="{ enabled: false }"
                                :auto-resize="true"
                                row-id="id"
                                :loading="table_loading"
                                :data="tableData"
                                :column-config="{ resizable: true }"
                                style="font-family: Arial, Helvetica, sans-serif;"
                                size="midium"
                                border="full"
                            >
                                <vxe-table-column
                                    v-for="col in cols"
                                    :key="col.field"
                                    :field="col.field"
                                    :title="col.title"
                                    :width="col.width"
                                    :title-help="col.msg"
                                    :sortable="col.sort"
                                ></vxe-table-column>
                                <vxe-table-column
                                    field="id"
                                    title="Browse"
                                    width="13%"
                                    v-if="tableData.length != 0"
                                    :title-help= "{ message: 'Click to view the association data' }"
                                >
                                    <template #default="{ row }">
                                        <el-button
                                            type="success"
                                            icon="el-icon-s-promotion"
                                            circle
                                            @click="goDB(row.id)"
                                            size="small"
                                        ></el-button>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>

                            <!-- <vxe-pager
                            :loading="loading"
                            :current-page="tablePage.currentPage"
                            :page-size="tablePage.pageSize"
                            :total="tablePage.totalResult"
                            :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                            @page-change="handlePageChange1"
                            ></vxe-pager>-->
                        </el-main>
                    </el-container>
                </el-container>
            </div>
        </div>
        <!-- <Doc :paras="paras"></Doc> -->

        <Footer></Footer>
    </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import axios from "axios/dist/axios.min";
import { api_dir, goToResultPage,help_msg } from "@/bus.js";



export default {
    name: 'browse',
    components: { Navi, Footer },
    data: function () {
        return {
            loading: true,
            treeData: [],
            treeProps: {
                children: 'children',
                label: 'label'
            },
            tableData: [],
            cols: [],
            tablePage: {
                currentPage: 1,
                pageSize: 10,
                totalResult: 0,
            },
            item_type: '',
            item: '',
            n_record: 'Related records',
            term_type: '',
            page_num: '4',
            update :true,
            table_loading:false,
        }
    },
    mounted: function () {
        this.loadTreeData();
    },
    // beforeRouteEnter(to, from, next) {
    //     if (from.name) {
    //         if (from.name.split('_')[0] == 'result') {
    //             console.log('cache')
    //             to.meta.keepAlive=true;
    //         } else {
    //             console.log('flush')
    //             to.meta.keepAlive=false;
    //         }
    //     }
    //     next();
    // },
    activated() {
        // this.$router.meta.keepAlive=true;
        this.update = false
        this.$nextTick(() => {
            this.update = true
        })
    },
    deactivated() {

    },
    methods: {
        handleNodeClick(obj, node, self) {
            if ('t' in obj) {
                console.log(obj['t']);
                this.item_type = obj['t'];
                this.item = obj['label'];
                this.loadTableData();
            }
        },
        loadTreeData() {
            var _this = this
            axios
                .get(api_dir + "/api.php?action=tree", {
                    params: { 'task_id': _this.task_id },
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    // _this.$notify({
                    //     title: "Success",
                    //     message: "Checked successfully",
                    //     type: "success",
                    //     duration: 2000,
                    // });
                    _this.treeData = res;
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.loading = false;
                });
        },
        loadTableData() {
            if (this.item_type == '') {
                return
            }
            this.table_loading=true;
            var para = { 'term': this.item }
            var arr = this.item_type.split(':');
            if (arr[0] == 'p') {
                this.term_type = 'phenotype';
                para['action'] = 'phenotype_tree_data';
                this.cols = [
                    { field: 'id', title: 'ID', width: '20%', msg: { message: 'GWAS ID' },sort:false },
                    { field: 'trait', title: 'Phenotype name', width: '29%', msg: { message: 'Phenotype description' },sort:true },
                    // {field:'mesh_term',title:'MeSH term',width:'30%',msg:{message: '自定义帮助提示信息'}},
                    { field: 'sample_size', title: 'Sample size', width: '20%', msg: { message: 'Sample size of GWAS' },sort:true },
                    { field: 'population', title: 'Population', width: '18%', msg: { message: 'Population of GWAS, see details in Help-Explanation' },sort:false },
                ];
            } else {
                this.term_type = 'cell';
                para['action'] = 'cell_tree_data';
                if (arr[0] == 'cc') {
                    para['tree_type'] = 'cell_type';
                    this.cols = [
                        { field: 'id', title: 'ID', width: '27%',msg: { message: 'Tissue/Cell-type ID' },sort:true },
                        { field: 'cell_type', title: 'Cell type', width: '20%',msg: { message: 'Tissue/Cell-type name' },sort:true },
                        { field: 'source', title: 'Source organ', width: '20%',msg: { message: 'Organ where the tissue/single cell type sampling' },sort:true },
                        { field: 'category_source', title: 'Category', width: '20%',msg: { message: 'Category of source organ' },sort:true },
                    ];
                } else {
                    para['tree_type'] = 'source';
                    this.cols = [
                        { field: 'id', title: 'ID', width: '37%',msg: { message: 'Tissue/Cell-type ID' },sort:true },
                        { field: 'cell_type', title: 'Cell type', width: '25%',msg: { message: 'Tissue/Cell-type name' },sort:true },
                        { field: 'category_cell_type', title: 'Category', width: '25%',msg: { message: 'Category of source organ' },sort:true },
                    ];
                }
                para['type'] = arr[1];
            }
            var _this = this
            axios
                .get(api_dir + "/api.php", {
                    params: para,
                })
                .then(function (response) {
                    _this.error_page = false;
                    var res = JSON.parse(JSON.stringify(response.data));
                    // _this.$notify({
                    //     title: "Success",
                    //     message: "Checked successfully",
                    //     type: "success",
                    //     duration: 2000,
                    // });
                    var itype = 'phenotypes';

                    var arr = _this.item_type.split(':');
                    if (_this.item_type != 'p') {
                        if (arr[1] == 'gtex') {
                            itype = 'tissues'
                        } else {
                            itype = 'single-cell types'
                        }
                    }
                    _this.n_record = 'Found ' + res.length + ' related ' + itype;
                    _this.tableData = res;
                    for (var v of _this.tableData) {
                        if ('cell_type_id' in v) {
                            v['id'] = v['cell_type_id'];
                        }
                    }

                    // console.log(res);
                })
                .catch(function (error) {
                    console.log(error);
                }).then(function () {
                    _this.table_loading=false;
                });
        },
        goDB(id) {
            goToResultPage(this.$router, this.term_type, id);
        }
    }
}
</script>



<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/browse.vue